export default __webpack_public_path__ + "static/media/daylotts10000_icon.396f95c4.svg";